import { h } from 'preact'
import InputGroup from '../ui-components/InputGroup'

export interface SSIHeaderData {
  url: string
}

interface Props extends SSIHeaderData {
  onChange: (header: SSIHeaderData) => void
}

const SSIHeader = ({ url, onChange }: Props) => {
  return (
    <InputGroup
      title='SSI URL'
      type='text'
      onChange={(e: ChangeEvent) => onChange({ url: e.target.value })}
      value={url} />
  )
}

export default SSIHeader
